<div class="full-height layout-column bringoz-table">

  <div class="tr text-uppercase layout-row layout-align-start-center">

    <div class="th large text-ellipsis layout-row layout-align-start-center flex">
      <span class="actions-button-width">{{ 'Full Name' | translate }}</span>
    </div>

    <div class="th small text-ellipsis flex-10">
      {{ 'Status' | translate }}
    </div>

    <div class="th small text-ellipsis flex-10">
      {{ 'External ID' | translate }}
    </div>

    <div class="th small text-ellipsis flex">
      {{ 'Vendor' | translate }}
    </div>

    <div class="th small text-ellipsis flex">
      {{ 'Branches' | translate }}
    </div>

    <div class="th small text-ellipsis flex-15">
      {{ 'Mobile' | translate }}
    </div>
    <div class="th small text-ellipsis flex-10">
      {{ 'Email (User name)' | translate }}
    </div>
    <div class="th small text-left text-ellipsis flex-10">
      {{ 'Vehicle' | translate }}
    </div>
  </div>

  <div class="full-height flex rows-container layout-column">
    <cdk-virtual-scroll-viewport [itemSize]="60" class="flex viewport" (scroll)="getNextBatch()">
      <div *cdkVirtualFor="let agent of agents"
           layout="column"
           class="item tr md-no-proxy fade-element-in-only table-row">

        <div class="flex layout-row layout-align-start-center">
          <div class="td large flex layout-row layout-align-start-center">
            <app-user-avatar [user]="agent.user"
                             [url]="agent.user.avatarUrl"
                             size="xsmall"
                             class="margin-right-5">
            </app-user-avatar>

            <div class="layout-column">
              <div class="layout-row layout-align-start-center">
                <app-agent-itinerary-link [linkToAgentView]="true"
                                          [agent]="agent"
                                          [isShowCopyButton]="true">
                </app-agent-itinerary-link>

                <app-agent-location *ngIf="!!agent.lastKnownLocation?.deviceReference"
                                    [location]="agent.lastKnownLocation?.coordinates"
                                    direction="right"
                                    [showText]="false"
                                    [locationTrackingApproval]="agent?.locationTrackingApproval"
                                    [gpsStatus]="agent.lastKnownLocation?.deviceReference?.gpsStatus"
                                    [gpsPermission]="agent.lastKnownLocation?.deviceReference?.gpsPermission"
                                    [lastUpdate]="agent.lastKnownLocation?.updatedAt">

                </app-agent-location>
              </div>
              <span
                class="br-body-2 font-weight-600 margin-top-5">{{ 'AGENT_TYPES.' + agent.agentType | translate }}</span>

            </div>


          </div>

          <!--Status-->
          <div class="td small layout-column flex-10 text-ellipsis">
            <span class="br-body-1 agent-status layout-row layout-align-start-center"
                  [ngbTooltip]="agentStatusUpdatedAtTooltip"
                  openDelay="300" triggers="hover" container="body"
                  [ngClass]="agent.status">{{ agent.status | translate }}</span>

            <ng-template #agentStatusUpdatedAtTooltip>
              <span class="br-body-2 font-weight-400">
                    {{ {statusUpdatedAt: agent.statusUpdatedAt} | bringozFullDate: 'statusUpdatedAt' }} {{ 'at' | translate }} {{ {statusUpdatedAt: agent.statusUpdatedAt} | bringozTime: 'statusUpdatedAt' }}
              </span>
            </ng-template>
          </div>

          <!--External ID-->
          <div class="td small layout-column flex-10 text-ellipsis">
            <span *ngIf="agent.externalId" class="br-body-2">{{ agent.externalId }}</span>
          </div>


          <!--Carrier-->
          <div class="td small text-ellipsis flex">
              <span *ngIf="agent.supplierAccount?.name" bringoz-ppi
                    class="br-body-2">{{ agent.supplierAccount?.name }}</span>
          </div>

          <!--Branches-->
          <div class="td small text-ellipsis flex">
            <branches-indicator *ngIf="agent.branches" class="br-body-2"
                                [branches]="agent.branches">

            </branches-indicator>
          </div>

          <!--Mobile-->
          <div class="td small flex-15">
            <span bringoz-ppi class="br-body-2">{{ agent.user.mobilePhone | bringozPhone }}</span>
          </div>

          <!--Email-->
          <div class="td small text-ellipsis flex-10">
            <span bringoz-ppi class="br-body-2">{{ agent.user.email }}</span>
          </div>

          <!--Vehicle-->
          <div class="td small text-center layout-row flex-10">
            <!--              <vehicle-type type="agent.vehicle.type"></vehicle-type>-->
            <span *ngIf="!!agent.vehicle" class="br-body-1 font-weight-400">{{ agent.vehicle.name }}</span>
          </div>

        </div>

      </div>
    </cdk-virtual-scroll-viewport>
  </div>

</div>
